import { createContext, useContext, createElement, useReducer } from 'react'

const initialState = {
  status: 'idle',
  error: null,
  dialogOpen: false,
  currentNode: null,
  insuranceId: null,
  vehicles: [],
  startDate: null,
  endDate: null,
  perMileUntil: new Date(),
  cancelationDate: new Date(),
  odometerImages: {},
  odometerValues: {},
  cancelationReason: null,
  cancelationAction: 'Regular',
  cancelationText: '',
  cancelationResult: null,
  showValidationInfo: false,
}

const context = createContext(initialState)
context.displayName = 'Cancel policy context'

const createProvider = (props, children) => createElement(context.Provider, props, children)

const reducer = (state, action) => {
  switch (action.type) {
    case 'REQUEST_START':
      return {
        ...state,
        status: 'busy',
      }
    case 'REQUEST_SUCCESS':
      return {
        ...state,
        status: 'idle',
      }
    case 'REQUEST_ERROR':
      return {
        ...state,
        status: 'idle',
        error: action.payload,
      }
    case 'SET_DIALOG_OPEN':
      return {
        ...state,
        dialogOpen: action.payload,
      }
    case 'SET_CURRENT_NODE':
      return {
        ...state,
        currentNode: action.payload,
        showValidationInfo: false,
      }
    case 'SET_INSURANCE_ID':
      return {
        ...state,
        insuranceId: action.payload,
      }
    case 'SET_POLICY_VEHICLES':
      return {
        ...state,
        vehicles: action.payload,
      }
    case 'SET_POLICY_DATES':
      return {
        ...state,
        startDate: action.payload.startDate,
        endDate: action.payload.endDate,
        perMileUntil: action.payload.perMileUntil,
      }
    case 'SET_CANCELATION_DATE':
      return {
        ...state,
        cancelationDate: action.payload,
      }
    case 'SET_CANCELATION_ACTION':
      return {
        ...state,
        cancelationAction: action.payload,
      }
    case 'ADD_ODOMETER_IMAGE':
      return {
        ...state,
        odometerImages: {
          ...state.odometerImages,
          [action.payload.id]: action.payload.file,
        },
      }
    case 'ADD_ODOMETER_MILAGE':
      return {
        ...state,
        odometerValues: {
          ...state.odometerValues,
          [action.payload.id]: action.payload.value,
        },
      }
    case 'SET_CANCELATION_REASON':
      return {
        ...state,
        cancelationReason: action.payload,
      }
    case 'SET_CANCELATION_TEXT':
      return {
        ...state,
        cancelationText: action.payload,
      }
    case 'SET_CANCELATION_RESULT':
      return {
        ...state,
        cancelationResult: action.payload,
      }
    case 'SET_VALIDATION_STATUS':
      return {
        ...state,
        showValidationInfo: action.payload,
      }
    case 'RESET':
      return {
        ...initialState,
      }
    default:
      return state
  }
}

let dispatch = null

export const Provider = ({ children }) => {
  const [state, dispatchFn] = useReducer(reducer, initialState)
  dispatch = dispatchFn
  return createProvider({ value: state }, children)
}
export const useCancelPolicyContext = () => {
  const state = useContext(context)
  if (state === null || dispatch === null) {
    throw new Error(`useCancelPolicyContext must be used inside a Provider.`)
  }
  return [state, dispatch]
}
